'use strict';

var React = require('react'),
    ResponsiveImageQueueMixin = require('../mixins/ResponsiveImageQueueMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    gradient = require('../utils/gradient'),
    { PropTypes } = React;

require('./BlurredBackground.less');

var BlurredBackground = React.createClass({
  mixins: [ResponsiveImageQueueMixin, PureRenderMixin, ClassNameMixin],

  propTypes: {
    background: PropTypes.shape({
      url: PropTypes.string.isRequired
    }).isRequired
  },

  getImageSizes() {
    return {
      'default': 480,
      'xs': 640,
      'sm': 640,
      'md': 640,
      'lg': 640,
      'xl': 640
    };
  },

  getImageOptions: function () {
    return {
      image: this.props.background,
      blur: 32,
      sizes: {
        small: true,
        normal: true
      }
    };
  },

  componentDidUpdate(prevProps) {
    if (prevProps.background !== this.props.background) {
      this.updateImageQueue();
    }
  },

  render() {
    var colors = this.props.background.colors,
        hasLoadedImage = this.hasLoadedImage(),
        style = {};

    if (hasLoadedImage) {
      style.backgroundImage = this.getBackgroundImageUrl();
    } else {
      style.backgroundImage = gradient('#' + colors.top, '#' + colors.bottom);
    }

    return (
      <div className={this.getClassName()}
           style={style}>
        {this.renderLoaderImg()}
      </div>
    );
  }
});

module.exports = BlurredBackground;



/** WEBPACK FOOTER **
 ** ./atoms/BlurredBackground.jsx
 **/